import { selectFromActivePlanningActionsDto } from '../../models';

export default selectFromActivePlanningActionsDto().actions(a => a.actionUuid.startDate.projectId.actionName.status.userUuid).toString();
